const ERROR_KEYS = {
  MATCH_LIMIT_REACHED:    "errors.matchLimitReached",
  AUTOTEST_LIMIT_REACHED: "errors.autotestLimitReached",
  CUP_FULL:               "errors.cupFull",
  TOO_MANY_ACTIVE_CUPS:   "errors.tooManyActiveCups",
  TOO_MANY_ORGANIZER_CUPS:"errors.tooManyOrganizerCups",
  PENDING_SENT:           "dashboard.pendingSent",
  PENDING_RECEIVED:       "dashboard.pendingReceived",
};

export function apiErrorMessage(e, t) {
  const key = ERROR_KEYS[e.message];
  return key ? t(key) : e.message;
}
